import { createSlice } from "@reduxjs/toolkit"

export const mostSpentCustomersSlice = createSlice({
	name: "most_spent",
	initialState: {
		mostSpent: "",
		errors: [],
	},

	reducers: {
        getMostSpent: (state, action) => {
        
			state.mostSpent = action.payload
		},
		getMostSpentList: (state, action) => {
		 
			state.mostSpent = action.payload
		},
		getErrors: (state, action) => {
			state.errors = action.payload
		},
	},
})
export const {getMostSpent, getMostSpentList, getErrors} = mostSpentCustomersSlice.actions

export default mostSpentCustomersSlice.reducer
